import { useTheme } from '@24i/nxg-sdk-higgs';
import { useTranslation } from 'react-i18next';

import { useStartPageNavigation } from '../../../context/AppStartContext/hooks';

import getOnboardingIntroStyles from '../styles';

const useViewModel = (props) => {
    const { theme } = useTheme();
    const styles = getOnboardingIntroStyles(theme);
    const { t } = useTranslation();
    const { navigateToStartPage } = useStartPageNavigation();

    return {
        ...props,
        title: t('onboarding.infoFirstTime.title'),
        description: t('onboarding.infoFirstTime.description'),
        buttonLabel: t('common.continue'),
        onPress: navigateToStartPage,
        styles,
    };
};

export { useViewModel };
